import {
  UPDATE_OPTIONS_LIST,
  UPDATE_MAX_PRICE,
  SET_ACTIVE_OPTION,
  SET_WAIT_STATUS,
  SET_ERROR_STATUS,
} from './constants';

const tradeInReducer = (state = null, action = {}) => {
  switch (action.type) {
    case UPDATE_OPTIONS_LIST: {
      const calculatorSettings = state.calculatorSettings || {};
      const slug = (action.payload || {}).slug || '';
      const list = (action.payload || {}).list || [];

      calculatorSettings.options = calculatorSettings.options.map((option) => {
        if (option.slug === slug) {
          option.list = list;
        }
        return option;
      });

      return {
        ...state,
        calculatorSettings,
      };
    }
    case UPDATE_MAX_PRICE: {
      return {
        ...state,
        calculatorSettings: {
          ...state?.calculatorSettings,
          ...(action?.payload?.maxPrice ?
            { maxPrice: action.payload.maxPrice }
          : { maxPrice: '0' }),
        },
      };
    }
    case SET_ACTIVE_OPTION: {
      const calculatorSettings = state.calculatorSettings || {};
      const slug = (action.payload || {}).slug || '';
      const activeOption = (action.payload || {}).activeOption || null;

      calculatorSettings.options = calculatorSettings.options.map((option) => {
        if (option.slug === slug) {
          option.activeOption = activeOption;
        }
        return option;
      });
      return {
        ...state,
        calculatorSettings,
      };
    }
    case SET_WAIT_STATUS: {
      const calculatorSettings = state.calculatorSettings || {};
      calculatorSettings.waitStatus = action.payload;
      return {
        ...state,
        calculatorSettings,
      };
    }
    case SET_ERROR_STATUS: {
      const calculatorSettings = state.calculatorSettings || {};
      calculatorSettings.errorStatus = action.payload;
      return {
        ...state,
        calculatorSettings,
      };
    }
    default:
      return state;
  }
};

export default tradeInReducer;
